<div class="w-100 h-100" style="overflow-y: auto; overflow-x: hidden">
	<p>{{ "SCAN_CARD_MESSAGE" | translated }}</p>
  <video class="w-50 d-block mb-4" style="margin-left: auto; margin-right: auto" autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
    <source src="assets/img/AssurCard_Animation.webm" type="video/webm" />
  </video>

	<app-btn [dataTxt]="'CARD_SCAN_BYPASS'" [classes]="'w-100 btnAnimation'" (callback)="onClickOk()" [icon]="'hand-point-right'" [iconLocation]="'left'" *ngIf="showBtnNext"></app-btn>
</div>
